export const InstagramIcon = ({ className = "h-5 w-5", ...rest }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" {...rest}>
    <defs>
      <radialGradient id="ig-grad" cx="30%" cy="107%" r="150%">
        <stop offset="0%" stopColor="#FDF497" />
        <stop offset="5%" stopColor="#FDF497" />
        <stop offset="45%" stopColor="#FD5949" />
        <stop offset="60%" stopColor="#D6249F" />
        <stop offset="90%" stopColor="#285AEB" />
      </radialGradient>
    </defs>
    <rect x="2" y="2" width="20" height="20" rx="5.5" fill="url(#ig-grad)" />
    <circle cx="12" cy="12" r="4.2" fill="none" stroke="#fff" strokeWidth="1.8" />
    <circle cx="17.3" cy="6.7" r="1.2" fill="#fff" />
    <rect x="2" y="2" width="20" height="20" rx="5.5" fill="none" stroke="#fff" strokeOpacity="0" />
    <rect x="5" y="5" width="14" height="14" rx="3.6" fill="none" stroke="#fff" strokeWidth="1.8" />
  </svg>
);

export const YoutubeIcon = ({ className = "h-5 w-5", ...rest }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" {...rest}>
    <path fill="#FF0000" d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8z" />
    <path fill="#fff" d="M9.6 15.6V8.4l6.2 3.6-6.2 3.6z" />
  </svg>
);

export const LinkedinIcon = ({ className = "h-5 w-5", ...rest }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" {...rest}>
    <rect x="1" y="1" width="22" height="22" rx="3.5" fill="#0A66C2" />
    <path fill="#fff" d="M6.8 9.4h2.9V18H6.8V9.4zM8.2 5.2a1.7 1.7 0 1 1 0 3.4 1.7 1.7 0 0 1 0-3.4zM11.5 9.4h2.8v1.2c.4-.7 1.4-1.4 2.8-1.4 3 0 3.5 2 3.5 4.5V18h-2.9v-3.8c0-.9 0-2.1-1.3-2.1s-1.5 1-1.5 2V18h-2.9V9.4h-.5z" />
  </svg>
);

export const FacebookIcon = ({ className = "h-5 w-5", ...rest }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" {...rest}>
    <circle cx="12" cy="12" r="11" fill="#1877F2" />
    <path fill="#fff" d="M15.6 12.9l.5-3.1h-3V7.8c0-.9.4-1.7 1.8-1.7h1.4V3.4s-1.3-.2-2.5-.2c-2.5 0-4.2 1.5-4.2 4.3v2.4H6.9v3.1h2.7V21h3.5v-8.1h2.5z" />
  </svg>
);

export const WhatsappIcon = ({ className = "h-6 w-6", ...rest }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true" {...rest}>
    <circle cx="12" cy="12" r="12" fill="#25D366" />
    <path fill="#fff" d="M12 4.5a7.5 7.5 0 0 0-6.4 11.4L4.5 19.5l3.7-1a7.5 7.5 0 1 0 3.8-14zm0 13.7a6.2 6.2 0 0 1-3.2-.9l-.2-.1-2.2.6.6-2.1-.2-.2A6.2 6.2 0 1 1 12 18.2zm3.4-4.6c-.2-.1-1.1-.5-1.3-.6-.2-.1-.3-.1-.4.1l-.6.8c-.1.1-.2.1-.4 0a5.1 5.1 0 0 1-2.5-2.2c-.2-.3.2-.3.5-1 .1-.1 0-.2 0-.3l-.6-1.4c-.2-.4-.3-.3-.4-.3h-.4a.7.7 0 0 0-.5.2 2.1 2.1 0 0 0-.7 1.6c0 .9.7 1.8.8 2 .1.1 1.3 2 3.2 2.8 1.2.5 1.6.5 2.2.4.4 0 1.1-.5 1.3-.9.2-.4.2-.8.1-.9l-.3-.3z" />
  </svg>
);
